/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Landing_Cockpit_Shop_CountInputs */

const tr_landing_cockpit_shop_count = /** @type {(inputs: Landing_Cockpit_Shop_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} mağaza`)
};

const en_landing_cockpit_shop_count = /** @type {(inputs: Landing_Cockpit_Shop_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} stores`)
};

const de_landing_cockpit_shop_count = /** @type {(inputs: Landing_Cockpit_Shop_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Shops`)
};

const ru_landing_cockpit_shop_count = /** @type {(inputs: Landing_Cockpit_Shop_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} магазина`)
};

/**
* | output |
* | --- |
* | "{count} stores" |
*
* @param {Landing_Cockpit_Shop_CountInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_cockpit_shop_count = /** @type {((inputs: Landing_Cockpit_Shop_CountInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Cockpit_Shop_CountInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_cockpit_shop_count(inputs)
	if (locale === "de") return de_landing_cockpit_shop_count(inputs)
	if (locale === "ru") return ru_landing_cockpit_shop_count(inputs)
	return tr_landing_cockpit_shop_count(inputs)
});